import React from 'react';
import { TableCell, Box, IconButton, CircularProgress } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { BUTTON_SIZES } from './constants';
import { isEyeDisabled, getEyeTooltip } from './helpers';

const IconButtons = ({ 
  entry, 
  deletingId, 
  onShowValidationErrors, 
  onDelete 
}) => (
  <TableCell align="center">
    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
      {/* Eye Button */}
      <IconButton
        disabled={isEyeDisabled(entry.validationFailedReason)}
        onClick={() => onShowValidationErrors(entry)}
        color="primary"
        title={getEyeTooltip(entry.validationFailedReason)}
        size={BUTTON_SIZES.ICON_BUTTON.size}
      >
        <VisibilityIcon />
      </IconButton>

      {/* Delete Button */}
      <IconButton
        onClick={() => onDelete(entry)}
        color="error"
        title="Delete file"
        disabled={deletingId === entry._id}
        size={BUTTON_SIZES.ICON_BUTTON.size}
      >
        {deletingId === entry._id ? (
          <CircularProgress size={20} />
        ) : (
          <DeleteIcon />
        )}
      </IconButton>
    </Box>
  </TableCell>
);

export default IconButtons;
